import { useSelector } from "react-redux";
import { useCallback } from "react";
import userSessionData from "../services/userSessionData";

export const useUserData = () => {
  const user = useSelector((state) => state.user);
  const sessionId = useSelector((state) => state.authSession.sessionId);
  const refreshUserData = useCallback(
    () => userSessionData.load({ expectedSessionId: sessionId }),
    [sessionId],
  );
  return { user, refreshUserData };
};
